import { ReactNode } from 'react';
import styled from 'styled-components';

import { color, space } from '../../stylesheets';
import Footer from '../Footer';

import Header from '../Header';

const Wrapper = styled.div<{ $background: 'neutral' | 'base'; $shade: number }>`
  position: relative;
  z-index: 2;
  background: ${props => color(props.$background, props.$shade)};
`;

const Container = styled.div`
  padding: calc(2 * ${space('xxl')}) ${space('m')};
  min-height: calc(100vh - ${space('xxl')});
  max-width: 700px;
  margin: 0 auto;
`;

type ContributeLayoutProps = {
  children: ReactNode;
  background?: 'neutral' | 'base';
  size?: 'narrow' | 'full';
};

const ContributeLayout = ({ children, background = 'neutral' }: ContributeLayoutProps) => (
  <div>
    <Wrapper $background={background} $shade={background === 'neutral' ? 10 : 50}>
      <Container>
        <Header />
        {children}
      </Container>
    </Wrapper>

    <Footer />
  </div>
);

export default ContributeLayout;
